<p-message
  severity="info"
  icon="fa fa-exclamation-circle"
  aria-label="tenant-info-message"
  data-testid="tenant-info-message"
>
  {{
    'STAFF.STAFF_PREFERENCE.TENANT_INFO_MSG'
      | translate: { count: tenantAccess.length }
  }}
</p-message>

@if (notificationsBlocked && hasSubscribedTopics) {
  <p-message
    severity="warn"
    aria-label="browser-notification-info-message"
    data-testid="browser-notification-info-message"
  >
    <div class="p-warn flex align-items-center w-full -my-2">
      <i class="fa fa-exclamation-triangle p-warn text-xl"></i>
      <div class="ml-3 line-height-3 text-sm">
        {{ 'STAFF.STAFF_PREFERENCE.BROWSER_NOTIFICATION_INFO' | translate }}
        <a
          href="https://knowledge.workspace.google.com/kb/how-to-enable-browser-notifications-000007831"
          target="_blank"
          class="text-primary underline"
          >{{
            'STAFF.STAFF_PREFERENCE.BROWSER_NOTIFICATION_INFO_LINK' | translate
          }}</a
        >
      </div>
    </div>
  </p-message>
}

<div class="flex align-items-center mb-3">
  <h6 class="text-sm mb-0">
    {{ 'STAFF.STAFF_PREFERENCE.NOTIFICATION_INFO' | translate }}
  </h6>
  @if (showDisableAll) {
    <p-button
      [label]="'STAFF.STAFF_PREFERENCE.DISABLE_ALL' | translate"
      (onClick)="disableAll()"
      styleClass="ml-2 p-0 underline font-bold text-sm p-button-link"
    />
  }
</div>

<div class="shadow-3 surface-0 border-round px-4 py-2">
  <form [formGroup]="notificationsForm">
    @if (showSkeleton) {
      <div>
        <div class="mb-3 flex align-items-center justify-content-between">
          <p-skeleton width="20rem" height="1.35rem" />
          <div class="flex align-items-center">
            <p-skeleton width="3rem" height="1.7rem" styleClass="mr-2" />
            <p-skeleton width="3rem" height="1.7rem" />
          </div>
        </div>
        <div class="mb-3 flex align-items-center justify-content-between">
          <p-skeleton width="20rem" height="1.35rem" />
          <div class="flex align-items-center">
            <p-skeleton width="3rem" height="1.7rem" styleClass="mr-2" />
            <p-skeleton width="3rem" height="1.7rem" />
          </div>
        </div>
        <div class="mb-3 flex align-items-center justify-content-between">
          <p-skeleton width="20rem" height="1.35rem" />
          <div class="flex align-items-center">
            <p-skeleton width="3rem" height="1.7rem" styleClass="mr-2" />
            <p-skeleton width="3rem" height="1.7rem" />
          </div>
        </div>
        <div class="mb-3 flex align-items-center justify-content-between">
          <p-skeleton width="20rem" height="1.35rem" />
          <div class="flex align-items-center">
            <p-skeleton width="3rem" height="1.7rem" styleClass="mr-2" />
            <p-skeleton width="3rem" height="1.7rem" />
          </div>
        </div>
        <div class="mb-3 flex align-items-center justify-content-between">
          <p-skeleton width="20rem" height="1.35rem" />
          <div class="flex align-items-center">
            <p-skeleton width="3rem" height="1.7rem" styleClass="mr-2" />
            <p-skeleton width="3rem" height="1.7rem" />
          </div>
        </div>
        <div class="mb-3 flex align-items-center justify-content-between">
          <p-skeleton width="20rem" height="1.35rem" />
          <div class="flex align-items-center">
            <p-skeleton width="3rem" height="1.7rem" styleClass="mr-2" />
            <p-skeleton width="3rem" height="1.7rem" />
          </div>
        </div>
        <div class="mb-3 flex align-items-center justify-content-between">
          <p-skeleton width="20rem" height="1.35rem" />
          <div class="flex align-items-center">
            <p-skeleton width="3rem" height="1.7rem" styleClass="mr-2" />
            <p-skeleton width="3rem" height="1.7rem" />
          </div>
        </div>
      </div>
    }
    @if (!showSkeleton) {
      <ul class="list-none p-0 m-0 text-sm text-700">
        @for (
          notification of staffSubscribedNotification.subscribed_topics;
          track notification
        ) {
          <li class="mb-3 flex align-items-center justify-content-between">
            <label class="font-normal">{{
              'STAFF.STAFF_PREFERENCE.' +
                notification.notificationSubscriptionTopic | translate
            }}</label>
            <div class="flex align-items-center ml-3">
              <p-select
                [options]="NotificationLevelEnum"
                [formControlName]="
                  notification.notificationSubscriptionTopic + '_level'
                "
                [placeholder]="'ADMIN.COMMON.SELECT' | translate"
                optionLabel="value"
                styleClass="mr-2"
                (onChange)="
                  UpdateLevel(
                    notification.notificationSubscriptionTopic,
                    $event
                  )
                "
              >
                <ng-template pTemplate="selectedItem">
                  @if (
                    getFormControl(
                      notification.notificationSubscriptionTopic + '_level'
                    ) &&
                    getFormControl(
                      notification.notificationSubscriptionTopic + '_level'
                    ).value
                  ) {
                    <div class="text-sm">
                      {{
                        getFormControl(
                          notification.notificationSubscriptionTopic + '_level'
                        ).value.value
                      }}
                    </div>
                  }
                </ng-template>
                <ng-template let-relationship pTemplate="item">
                  <div class="text-sm">{{ relationship.value }}</div>
                </ng-template>
              </p-select>
              <p-toggleSwitch
                [formControlName]="notification.notificationSubscriptionTopic"
                (onChange)="
                  UpdateValue(
                    notification.notificationSubscriptionTopic,
                    $event
                  )
                "
              />
            </div>
          </li>
        }
      </ul>
    }
  </form>
</div>
